export default __webpack_public_path__ + "static/media/studyMaterialIcon.22344482.svg";